import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BarsIcon, ChatIcon, TrendIcon } from "@/assets/icons";
import cls from "./styles.module.scss";

const TABS = [
  { to: "/", key: "tabs.compare", Icon: TrendIcon },
  { to: "/stats", key: "tabs.stats", Icon: BarsIcon },
  { to: "/chat", key: "tabs.chat", Icon: ChatIcon },
] as const;

export const TabBar = () => {
  const { t } = useTranslation();
  const { search } = useLocation();

  return (
    <nav className={cls.tabbar}>
      {TABS.map(({ to, key, Icon }) => (
        <NavLink
          key={to}
          to={{ pathname: to, search }}
          end
          className={({ isActive }) =>
            [cls.tab, isActive ? cls.active : ""].join(" ")
          }
        >
          <Icon />
          {t(key)}
        </NavLink>
      ))}
    </nav>
  );
};
